import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginServicesService } from '../shared/services/login-services.service';
import { Component, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faFileExport,
  faInfoCircle,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-jira-testing',
  templateUrl: './jira-testing.component.html',
  styleUrls: ['./jira-testing.component.scss']
})
export class JiraTestingComponent implements OnInit {
  private allItems: any = [];
  pager: any = {};
  pagedItems: any = [];
  clickEventsubscriptionSocket: Subscription;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private loginService: LoginServicesService,
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    private appService: AppService,
    private pagerService: PagerService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  personaMapUI: any;
  deSelectCollection: any;
  eutCollection: any = { TF: [], UR: [], BF: [] };
  personas: any;
  personaMap: any;
  listOfEUTs: any;
  selectedEUT: any;

  EUTtypes: any = ['TF', 'UR', 'BF'];
  modelData: any;
  disableDown: any;
  disableUp: any;
  filterTypeCount: any = { type: 'count' };

  jiraProjectList: any = [];
  jiraStoriesList:any = [];

  ngOnInit(): void {
    let authorizationData = 'Basic ' + btoa('sreesailam.avinash489@gmail.com' + ':' + 'M3rOpjkP29RxanDi6Y0QFF3F')
    this.loginService.getAllJiraProjects(authorizationData).subscribe((response: any) => {
      // console.log("getAllJiraProjects", response);
      this.jiraProjectList = response;
    })
    // console.log('jiraProjectList', this.jiraProjectList);
    this.loginService.getAllJiraStories(authorizationData).subscribe((response: any) => {
      // console.log("getAllJiraStories", response);
      this.jiraStoriesList = response.issues;
    })
  }

}
